import { useCallback, useEffect, useState } from 'react';
import api from '../lib/api';

export default function useCartQuote(items, enabled = true) {
  const request = JSON.stringify({ items: items.map(item => ({ product_id: item.product_id, quantity: item.quantity })) });
  const [state, setState] = useState({ request: null, quote: null, loading: false, error: false });
  const [version, setVersion] = useState(0);
  const retry = useCallback(() => setVersion(value => value + 1), []);
  const hasItems = items.length > 0;

  useEffect(() => {
    const onVisible = () => { if (document.visibilityState === 'visible') retry(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, [retry]);

  useEffect(() => {
    if (!enabled || !hasItems) return;
    const controller = new AbortController();
    setState({ request, quote: null, loading: true, error: false });
    api.post('/cart/quote', JSON.parse(request), { signal: controller.signal, timeout: 15000 })
      .then(response => {
        if (!controller.signal.aborted) setState({ request, quote: response.data, loading: false, error: false });
      })
      .catch(() => {
        if (!controller.signal.aborted) setState({ request, quote: null, loading: false, error: true });
      });
    return () => controller.abort();
  }, [request, enabled, hasItems, version]);

  // Never display an old total for newly changed quantities, even for one frame.
  if (!enabled || !hasItems) return { quote: null, loading: false, error: false, retry };
  if (state.request !== request) return { quote: null, loading: true, error: false, retry };
  return { ...state, retry };
}
